import styled, { css } from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

type StyledPractitionerCellProps = {
   $important: boolean;
};

export const StyledPractitionerCell = styled(StyledFlex)<StyledPractitionerCellProps>`
   padding: 11px 8px;
   height: 100%;

   ${(props) =>
      props.$important &&
      css`
         background-color: ${props.theme.primaryBackground};
      `}
`;
StyledPractitionerCell.displayName = 'StyledPractitionerCell';
